/**
 * Mobile device detection utilities.
 *
 * The old bottom-band D-pad offset helpers (getMobileOffset,
 * adjustUIForMobile, createMobileButton) died with mobileControls.js - touch
 * input is now the floating thumbstick in src/input/touchControls.js, which
 * reserves no screen band, so UI elements keep their normal positions.
 */
export const MobileUtils = {
  /**
   * Check if current device is mobile
   */
  isMobile() {
    return /Mobi|Android|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i.test(navigator.userAgent);
  },

  /**
   * Check if device is in portrait orientation
   */
  isPortrait() {
    return window.innerHeight > window.innerWidth;
  },
};
